import {ListUtility} from '../../../Utils/ListUtility'
import {AdminSignboardInfo, AdminSignboardInfoDTO, AdminSignboardInfoJSON} from "./AdminSignboardInfoDTO"
import {MailMagazine, MailMagazineDTO, MailMagazineJSON} from "../../Member/DTO/MailMagazineDTO"
import {Nullable} from "../../../../Common/TypeHelper"
import {UrlUtility} from "../../../Utils/UrlUtility"

export interface AdminBucketInfo {
  id: number
  bucketKey: string
  name: string
  logoImgUrl?: string
  shopId?: Nullable<string>
  mailMagazineList?: MailMagazine[]
  urlList?: AdminBucketUrl[]
  signboardList?: AdminSignboardInfo[]
  dependOnList?: AdminBucketHeader[]
  requiredByList?: AdminBucketHeader[]
}

export type AdminBucketUrl = {
  type: string
  url: string
  urlReplaceStyle: string
  name: string
}

export type AdminBucketHeader = {
  id: number
  bucketKey: string
  name: string
}

export interface AdminBucketInfoJSON {
  id: number
  bucketKey: string
  name: string
  shopId?: Nullable<string>
  mailMagazineList?: MailMagazineJSON[]
  urlList?: AdminBucketUrl[]
  signboardList?: AdminSignboardInfoJSON[]
  dependOnList?: AdminBucketHeader[]
  requiredByList?: AdminBucketHeader[]
}

export class AdminBucketInfoDTO implements AdminBucketInfo {
  id: number
  bucketKey: string
  name: string
  logoImgUrl?: string
  shopId?: Nullable<string>
  mailMagazineList?: MailMagazine[]
  urlList?: AdminBucketUrl[]
  signboardList?: AdminSignboardInfo[]
  dependOnList?: AdminBucketHeader[]
  requiredByList?: AdminBucketHeader[]

  constructor(
    id: number,
    bucketKey: string,
    name: string,
    logoImgUrl?: string,
    shopId?: Nullable<string>,
    mailMagazineList?: MailMagazine[],
    urlList?: AdminBucketUrl[],
    signboardList?: AdminSignboardInfo[],
    dependOnList?: AdminBucketHeader[],
    requiredByList?: AdminBucketHeader[],
  ) {
    this.id = id
    this.bucketKey = bucketKey
    this.name = name
    this.logoImgUrl = logoImgUrl
    this.shopId = shopId
    this.mailMagazineList = mailMagazineList
    this.urlList = urlList
    this.signboardList = signboardList
    this.dependOnList = dependOnList
    this.requiredByList = requiredByList
  }

  static fromJSON(jsonObject: AdminBucketInfoJSON): AdminBucketInfoDTO {
    const logoImgUrl = ListUtility.findOne<AdminBucketUrl>(
      jsonObject.urlList || [],
      item => item.type === 'logoImg',
    )

    return new AdminBucketInfoDTO(
      jsonObject.id,
      jsonObject.bucketKey,
      jsonObject.name,
      logoImgUrl ? UrlUtility.buildUrl(logoImgUrl) : undefined,
      jsonObject.shopId,
      jsonObject.mailMagazineList?.map(item => ({...MailMagazineDTO.fromJSON(item)})),
      jsonObject.urlList,
      jsonObject.signboardList?.map(item => ({...AdminSignboardInfoDTO.fromJSON(item)})),
      jsonObject.dependOnList,
      jsonObject.requiredByList,
    )
  }
}
